<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card>
      <v-toolbar>
        <v-toolbar-title class="primary--text font-weight-bold"
          >Registrar Pesagens</v-toolbar-title
        >
      </v-toolbar>

      <v-card-text class="pt-5">
        <v-form ref="form" >
          <v-select
            label="Material"
            class="font-weight-medium"
            :items="
              configuracoes.dados.materiais_pesagem.filter(
                (mp) =>
                  visita.peneiras.findIndex(
                    (p) => p.tipo.toLowerCase() == mp.tipo.toLowerCase()
                  ) < 0
              )
            "
            no-data-text="Nenhum material encontrado"
            :rules="[(v) => !!v || 'Informe o tipo de material']"
            outlined
            item-text="tipo"
            item-value="tipo"
            v-model="pesagem.tipo"
          ></v-select>

          <h3 class="mt-2 mb-4">Pesagem Peneiras (gramas)</h3>
          <v-text-field
            label="Peneira superior - partícula > 1,90 cm"
            v-model="pesagem.peneira_superior"
            :dense="isMobile()"
            inputmode="numeric"
            pattern="[0-9]*"
            outlined
            suffix="g"
          ></v-text-field>
          <v-text-field
            label="Peneira superior - partícula 0,78 - 1,90 cm"
            v-model="pesagem.peneira_media"
            :dense="isMobile()"
            inputmode="numeric"
            pattern="[0-9]*"
            outlined
            suffix="g"
          ></v-text-field>
          <v-text-field
            label="Peneira inferior - Partícula < 0,78 cm"
            v-model="pesagem.peneira_inferior"
            :dense="isMobile()"
            inputmode="numeric"
            pattern="[0-9]*"
            outlined
            suffix="g"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false">Cancelar</v-btn>
        <v-btn
          @click="registrarPesagem()"
          color="success"
          class="font-weight-bold"
          >Confirmar pesagem</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      }
    },
  },
  computed: mapState("visitaTecnica", ["configuracoes", "visita"]),
  data: () => ({
    dialog: false,
    pesagem: {
      id: 0,
      tipo: "",
      peneira_superior: 0.00,
      peneira_media: 0.00,
      peneira_inferior: 0.00,
      peso_total: 0.00,
      perc_pen_superior: 0.00,
      perc_pen_media: 0.00,
      perc_pen_inferior: 0.00,
      tabela: [],
    },
  }),
  methods: {
    calcularPerc(val) {
      return parseFloat(((val * 100) / this.pesagem.peso_total).toFixed(2));
    },
    registrarPesagem() {
      if (this.$refs.form.validate()) {
        this.pesagem.peneira_superior = parseFloat(
          this.pesagem.peneira_superior
        );
        this.pesagem.peneira_media = parseFloat(this.pesagem.peneira_media);
        this.pesagem.peneira_inferior = parseFloat(
          this.pesagem.peneira_inferior
        );

        this.pesagem.peso_total =
          this.pesagem.peneira_superior +
          this.pesagem.peneira_media +
          this.pesagem.peneira_inferior;

        this.pesagem.perc_pen_superior = this.calcularPerc(
          this.pesagem.peneira_superior
        );
        this.pesagem.perc_pen_media = this.calcularPerc(
          this.pesagem.peneira_media
        );
        this.pesagem.perc_pen_inferior = this.calcularPerc(
          this.pesagem.peneira_inferior
        );

        this.visita.peneiras.push(this.pesagem);
        this.dialog = false;
      }
    },
    isMobile() {
      return this.$mq == "sm";
    },
  },
  mounted() {
    this.dialog = true;
  },
};
</script>

<style>
</style>